import { Link } from '@tanstack/react-router';
import { Megaphone } from 'lucide-react';

import type { HomeAnnouncement } from '@/lib/api/home';

function relativeTime(iso: string): string {
  const mins = Math.floor((Date.now() - new Date(iso).getTime()) / 60_000);
  if (mins < 60) return `${Math.max(mins, 0)}m ago`;
  const hours = Math.floor(mins / 60);
  if (hours < 24) return `${hours}h ago`;
  const days = Math.floor(hours / 24);
  return days === 1 ? 'Yesterday' : `${days} days ago`;
}

export function BatchAnnouncementCard({ announcements }: { announcements: HomeAnnouncement[] }) {
  const latest = announcements[0];
  if (!latest) return null;
  const [headline, ...rest] = latest.content.split('\n');
  const body = rest.join(' ').trim();

  return (
    <section className="flex flex-col rounded-[20px] border border-[#ececec] bg-white p-[25px] shadow-[0px_1px_1.5px_rgba(0,0,0,0.1),0px_1px_1px_rgba(0,0,0,0.1)]">
      <div className="flex items-center justify-between">
        <h3 className="text-sm font-bold text-[#111827]">Latest Announcement</h3>
        <Link to="/schedule" className="text-xs font-semibold text-[#8b5cf6] transition-opacity hover:opacity-75">View all</Link>
      </div>
      <div className="mt-6 rounded-2xl p-5" style={{ background: 'linear-gradient(157.88deg, #f5f3ff 0%, #ede9fe 100%)' }}>
        <div className="flex items-start gap-3">
          <span className="flex size-10 shrink-0 items-center justify-center rounded-xl bg-white shadow-[0px_1px_1.5px_rgba(0,0,0,0.1),0px_1px_1px_rgba(0,0,0,0.1)]">
            <Megaphone className="size-[18px] text-[#8b5cf6]" />
          </span>
          <div className="min-w-0">
            <p className="text-sm font-bold text-[#111827]">{headline}</p>
            {body && <p className="pt-1 text-xs leading-[16.5px] text-[#6b7280]">{body}</p>}
          </div>
        </div>
        <p className="pt-4 text-xs text-[#9ca3af]">{relativeTime(latest.created_at)}</p>
      </div>
    </section>
  );
}
